import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { defaultActiveActuals, sortOptionsByForecastProducts } from "../../consts/forecastPlanning/client"
import { monthsLowerCase } from "../../consts/forecast";
import { formatPrice } from "../../helpers/common";
import { exportActualsVsForecastToCSV } from "../../helpers/planning/exports";
import { SortOrderSelect } from "./SortOrderSelect";

export const ActualsVSForecastHeader = ({
    selectedForecastYear,
    forecastProducts,
    groupsBySelect,
    activeActuals,
    setActiveActuals,
    sortOrder,
    setSortOrder,
    onChangeSortOrder,
}) => {
    const monthsLong = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    const exportTableToCSV = () => exportActualsVsForecastToCSV({ selectedForecastYear, forecastProducts, groupsBySelect, sortOrder });
    return (
        <div className="px-6">
            <div className="flex items-center justify-between gap-2 flex-wrap">
                <div className="flex flex-row gap-4">
                    <div>
                        <h4 className="leading-none font-semibold">
                            {selectedForecastYear} YTD Revenue Actuals vs Forecast
                        </h4>
                        <p className="text-sm">
                            {selectedForecastYear} YTD actual performance compared to {selectedForecastYear} forecast
                        </p>
                    </div>
                </div>
                <div className="flex flex-row gap-4 flex-wrap">
                    <div className="flex items-center gap-3">
                        <div className="flex items-center gap-3 text-xs">
                            {defaultActiveActuals.map((item) => {
                                const isActive = (activeActuals || []).includes(item.value);
                                return (
                                    <button
                                        key={item.value}
                                        onClick={() => {
                                            setActiveActuals((prev) => {
                                                const current = prev || [];
                                                const exists = current.includes(item.value);
                                                return exists
                                                    ? current.filter((v) => v !== item.value)
                                                    : [...current, item.value];
                                            });
                                        }}
                                        aria-pressed={isActive}
                                        className={`flex items-center gap-1 px-2 py-1 rounded bg-gray-100 ${!isActive ? "opacity-50" : ""}`}
                                    >
                                        <div className={`w-2 h-2 rounded-full ${item.color}`} />
                                        <span>{item.label}</span>
                                    </button>
                                )
                            })}
                        </div>
                    </div>
                    <SortOrderSelect 
                        options={sortOptionsByForecastProducts} 
                        value={sortOrder} 
                        onChange={(val) => {
                            setSortOrder?.(val);
                            onChangeSortOrder?.(val);
                        }} 
                    />
                    <button onClick={exportTableToCSV} className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 shrink-0 outline-none border bg-white shadow-xs h-8 rounded-md gap-1.5 px-3 hover:bg-black hover:text-white">
                        <ArrowDownTrayIcon className="h-5 w-5" />
                        <span>Export CSV</span>
                    </button>
                </div>
            </div>
        </div>
    )
}